import React from "react";

function EmployeeDashboard() {
  return (
    <div className="flex flex-col gap-6">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <p className="text-gray-600">You are logged in to the employee portal.</p>
      </div>
    </div>
  );
}

export default EmployeeDashboard;
